import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import CompanyLookup from './components/CompanyLookup';
import MessageContainer from './components/MessageContainer';
import Footer from './components/Footer';
import './App.css';

const PageHeader = () => {
  return (
    <div className="page-header">
      <div className="logo-section">
        <img 
          src="/IDTA_Logo_Blue_Web_M.png" 
          alt="IDTA" 
          className="page-logo"
        />
      </div>
    </div>
  );
};

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <i className="bi bi-chevron-up"></i>
    </button>
  );
};

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <div className="App">
        <main className="main-content">
          <div className="container">
            <PageHeader />
            
            {/* Company Lookup Section - MX Discovery */}
            <CompanyLookup />
          </div>
        </main>
        <Footer />
        <MessageContainer />
        <ScrollToTop />
      </div>
    </Router>
  );
}

export default App;
